import { useState } from "react";

import { Button } from "@icg360/design-system";

import { EditMortgageeModal } from "pages/settings/payment/payment-item/edit-mortgagee/edit-mortgagee-modal";
import { type PolicyDetail, trackEvent } from "utils";

type EditMortgageeProps = {
  mortgagee: NonNullable<
    NonNullable<PolicyDetail["userBilling"]>["mortgagees"]
  >[number];
  keystonePolicyId: string;
};

const EditMortgagee = ({ mortgagee, keystonePolicyId }: EditMortgageeProps) => {
  const [showEditModal, setShowEditModal] = useState(false);

  const openModal = () => {
    setShowEditModal(true);
    trackEvent("Edit mortgagee modal displayed");
  };

  return (
    <>
      <Button
        appearance="tertiary"
        size="xs"
        onPress={openModal}
        data-testid="edit-mortgagee-btn"
      >
        Edit
      </Button>
      <EditMortgageeModal
        open={showEditModal}
        onClose={() => setShowEditModal(false)}
        keystonePolicyId={keystonePolicyId}
        index={mortgagee.index ?? 0}
      />
    </>
  );
};

export default EditMortgagee;
